import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setUserData } from '../../../../Redux/user/userSlice';
import { setComplaintsList, fetchComplaintDetails } from '../../../../Redux/complaints/complaintsSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

export const fetchComplaintsLists = async ({ params, dispatch }) => {
  params.type = 'store'; // Add this line to include the store refund filter
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/complaint/list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setComplaintsList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
    }
    // this loader added because in case order not returned the success message
  }
};

// Function to update refund status
export const updateRefundStatus = async ({ refund_id, status, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/oms-service/update-refund-status`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      refund_id,
      status,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};


// Fetch orders by phone number for complaint creation
export const fetchUserByMobile = async ({ mobile, country = 'ae', dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/complaint/search-order`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ phone: mobile, country }),
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401 && dispatch) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

// Create complaint API (multipart/form-data)
export const createComplaint = async ({
  customer_name,
  country,
  mobile,
  order_no = '',
  sku = '',
  complaint_remark = '',
  complaint_category = '',
  complaint_subcategory = '',
  complaint_detail_category = '',
  created_by = '',
  oms_user_id = '',
  email = '',
  files = [],
  dispatch
}) => {
  const bearerToken = UserAuthKey();
  const formData = new FormData();
  // Attach files (multiple allowed)
  if (files && files.length > 0) {
    files.forEach((file) => {
      formData.append('upload_image[]', file);
    });
  }
  formData.append('customer_name', customer_name);
  formData.append('country', country);
  formData.append('mobile', mobile);
  formData.append('order_no', order_no);
  formData.append('sku', sku);
  formData.append('complaint_remark', complaint_remark);
  formData.append('complaint_category', complaint_category);
  formData.append('complaint_subcategory', complaint_subcategory);
  formData.append('complaint_detail_category', complaint_detail_category);
  formData.append('created_by', created_by);
  formData.append('oms_user_id', oms_user_id);
  formData.append('email', email);
  formData.append('type', 'complaint');


  const config = {
    method: 'POST',
    url: `${apiUrl}v1/complaint/create`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      // 'Content-Type' will be set automatically by axios for FormData
    },
    data: formData,
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401 && dispatch) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

// Fetch Complaint Details
export const getComplaintDetails = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/v1/complaint/details`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(fetchComplaintDetails(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
    }
  }
};

export const updateComplaintStatus = async ({ complaint_no, status, remark, updated_by, dispatch }) => {
      const bearerToken = UserAuthKey();
      const config = {
    method: 'POST',
    url: `${apiUrl}v1/complaint/change-status`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      complaint_no,
      status,
      remark,
      updated_by,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};